import apiClient from './api';

export interface ToggleWishlistRequest {
  menuId: number;
  active: boolean;
  wishlistId?: number;
}

export interface ToggleWishlistResponse {
  success: boolean;
  active: boolean;
  message?: string;
  requiresLogin?: boolean;
}

class WishlistService {
  /**
   * Toggle wishlist item (add/remove)
   */
  async toggleWishlist(
    appName: string,
    menuId: number,
    active: boolean,
    wishlistId?: number
  ): Promise<ToggleWishlistResponse> {
    const response = await apiClient.post(
      `/api/restaurants/${appName}/wishlist/toggle`,
      {
        menuId,
        active,
        wishlistId,
      }
    );
    return response.data;
  }
}

export default new WishlistService();

